<template>
  <Modal
    v-model="visible"
    title="详情"
    width="1024"
    :closable="false"
    :mask-closable="false"
  >
    <div style="height: 400px">
      <div>
        <DatePicker
          v-model="searchDate"
          type="daterange"
          placement="bottom-end"
          placeholder="选择游戏时间"
          style="width: 200px"
        ></DatePicker>
        <Button type="primary" @click="queryGoods">查询</Button>

        <div style="overflow: auto; height: 330px">
          <Table
            :columns="columns1"
            :data="data1"
            :scroll="{ y: 100 }"
            height="330"
          >
          </Table>
        </div>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              :total="total"
              :page-size="50"
              :current="current"
              @on-change="changePage"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="guanbimodal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import { cmsDevilcityGamelist } from "../../api/machine";

export default {
  data() {
    return {
      searchDate: [],
      searchDate1: [],
      data1: [], // 用于存储查询结果
      columns1: [
        {
          title: "上机时间",
          key: "uptime",
        },
        {
          title: "下机时间",
          key: "downtime",
        },
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "上机前金币",
          key: "upmoney",
        },
        {
          title: "花费金币",
          key: "coinnumber",
        },
        // {
        //   title: "获得礼品",
        //   key: "wingiftname",
        //   render: (h, params) => {
        //     return h(
        //       "span",

        //       params.row.wingiftname + "*" + params.row.wingiftnum
        //     );
        //   },
        // },
        {
          title: "获得金币",
          key: "wincoin",
        },
      ],

      current: 1,
      total: 0,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    user_id: {
      type: String,
      required: true,
    },
    roomid: {
      type: String,
      required: true,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 当模态框打开时，清空备注内容
        this.searchDate = [];
        this.data1 = [];
        this.current = 1;
        this.total = 0;
        this.queryGoods();
      }
    },
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    changeTab(index) {
      if (index == 0 && this.data1.length == 0) {
        this.queryGoods();
      }
    },
    guanbimodal() {
      this.$emit("guanbimodal");
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        machineNumber: this.user_id,
        roomid: this.roomid,
        starttime,
        endtime,
        page: this.current,
      };
      cmsDevilcityGamelist(params)
        .then((response) => {
          this.data1 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
  },
};
</script>

<style scoped>
/* 添加一些样式，如果需要的话 */
</style>
